const PASSENGER_LANGUAGE_LABELS: Record<string, string> = {
    AR: "Arapça",
    ARABIC: "Arapça",
    ENG: "İngilizce",
    EN: "İngilizce",
    ENGLISH: "İngilizce",
    FR: "Fransızca",
    FRENCH: "Fransızca",
    DE: "Almanca",
    DEU: "Almanca",
    GERMAN: "Almanca",
    ITA: "İtalyanca",
    IT: "İtalyanca",
    ITALIAN: "İtalyanca",
    PT: "Portekizce",
    PORTUGUESE: "Portekizce",
    ES: "İspanyolca",
    SPANISH: "İspanyolca",
    TR: "Türkçe",
    TURKISH: "Türkçe",
};

export function getPassengerLanguageLabel(language?: string): string | null {
    if (!language) return null;
    const normalized = language.trim().toUpperCase();
    return PASSENGER_LANGUAGE_LABELS[normalized] ?? language;
}
